import { DISTRIBUTION_URL, LABEL_URL } from "../../../services/common-urls";
import { HttpClient, JSON_STRING, MHTTPCL, createHttpGetOptions } from "../../../services/http/http-client";
import * as querystring from 'qs';

const SECSTATEMENT = "statementsin"

export const DistributionStatementService = {

    statementList: () => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "statement_list"
    }),

    statementStatusInQueue: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "statement_status_in_queue",
        statement_id: statement_id
    }),

    deleteStatement: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "delete_statement",
        statement_id: statement_id
    }),

    statementFilter: ({ searchString = "", digital_physical = "", statement_year = "", invoice_filter = "", statement_period_txt = "" }) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "statement_filter",
        search_keys1: searchString,
        digital_physical: digital_physical,
        statement_year: statement_year,
        invoice_filter: invoice_filter,
        statement_period_txt: statement_period_txt
    }),

    processStatement: (statement_id, file_type) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: "statementsin",
        action: "process_statement",
        statement_id: statement_id,
        file_type: file_type,
    }),

    //sidewindow

    statementSummaryData: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "statement_summary_data",
        statement_id: statement_id
    }),

    //import

    statementData: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "statement_data",
        statement_id: statement_id,
        output: JSON_STRING
    }),

    statementImportData: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "statement_import_data",
        statement_id: statement_id,
        output: JSON_STRING
    }).then(res => {
        // console.log("[::::::::::", res, ":::::::::::::]")
        return {
            ...res,
            data: {
                ...res.data,
                file: {
                    imported_data: []
                },
                conf: {
                    column_names: res.data?.conf ? eval(res.data.conf.column_names) : []
                }
            }
        };
    }),

    channelPresets: (channel) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "channel_presets",
        channel: channel,
        output: JSON_STRING
    }),

    setPreset: (statement_id, statement_preset_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "set_preset",
        statement_id: statement_id,
        statement_preset_id: statement_preset_id,
        output: JSON_STRING
    }),

    saveStatementConf:
        (
            {
                statement_id,
                fix_country = '',
                fix_shop = '',
                return_handling_fee = '',
                distribution_fee_sales = '',
                distribution_fee_returns = '',
                return_identifier = '',
                fix_digital_type = '',
                returns_have_leading_minus = '0',
                column_names = []
            }
        ) => MHTTPCL.post(DISTRIBUTION_URL, {
            section: SECSTATEMENT,
            action: "save_statement_conf",
            statement_id: statement_id,
            fix_country: fix_country,
            fix_shop: fix_shop,
            return_handling_fee: return_handling_fee,
            distribution_fee_sales: distribution_fee_sales,
            distribution_fee_returns: distribution_fee_returns,
            return_identifier: return_identifier,
            fix_digital_type: fix_digital_type,
            returns_have_leading_minus: returns_have_leading_minus,
            column_names: JSON.stringify(column_names)

        }),

    refreshStatementCalculation: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "refresh_statement_calculation",
        statement_id: statement_id
    }),










    //import result
    //physical  
    physicalStmtImportResultData: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "physical_stmt_import_result_data",
        statement_id: statement_id,
        output: JSON_STRING
    }),
    //digital 
    digitalStmtImportResultData: (statement_id, start = 0, end = 20) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "digital_stmt_import_result_data",
        statement_id: statement_id,
        start: start,
        end: end,
        output: JSON_STRING
    }),
    ppuByFixAmount: (statement_id, amount) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "ppu_by_fix_amount",
        statement_id: statement_id,
        amount: amount,
        output: JSON_STRING
    }),

    //costs
    costIncomeStmtImportResultData: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "cost_income_stmt_import_result_data",
        statement_id: statement_id,
        output: JSON_STRING
    }),

    thirdpartyPerformanceStmtImportResultData: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "thirdparty_performance_stmt_import_result_data",
        statement_id: statement_id,
        output: JSON_STRING
    }),

    deleteMatchingStatementline: (statement_line_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "delete_matching_statementline",
        statement_line_id: statement_line_id,
        output: JSON_STRING

    }),

    updateStatementPriceListId: ({ statement_id, price_list_id }) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "update_statement_price_list_id",
        statement_id: statement_id,
        price_list_id: price_list_id,
        output: JSON_STRING

    }),





    //sales details

    statementImportResultData: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "statement_import_result_data",
        statement_id: statement_id
    }).then(res => {
        return {
            ...res,
            data: {
                sales_details: res.data.statement_lines.slice(0, 50),
            }
        };
    }),

    statementIncomeData: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "statement_income_data",
        statement_id: statement_id
    }).then(res => {
        return {
            ...res,
            data: {
                cost_income_details: res.data.statement_lines,
                cost_groups: res.data.cost_groups
            }
        };
    }),

    statementCostsData: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "statement_costs_data",
        statement_id: statement_id
    }).then(res => {
        return {
            ...res,
            data: {
                cost_details: res.data.statement_lines,
                cost_groups: res.data.cost_groups
            }
        };
    }),














    //import matching
    statementImportErrorData: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "statement_import_error_data",
        statement_id: statement_id,
        output: JSON_STRING

    }),

    statementImportErrorPage: (statement_id, start) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "statement_import_error_page",
        statement_id: statement_id,
        start: start,
        output: JSON_STRING

    }),

    deleteNonMatchingStatementline: (statement_line_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "delete_non_matching_statementline",
        statement_line_id: statement_line_id
    }),

    groupByIdentifier: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "group_by_identifier",
        statement_id: statement_id,
        output: JSON_STRING
    }),

    checkSupplierIds: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "check_supplier_ids",
        statement_id: statement_id,
        output: JSON_STRING
    }),

    updateArtistTitleMatch: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "update_artist_title_match",
        statement_id: statement_id
    }),

    deleteAllUnmatched: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "delete_all_unmatched",
        statement_id: statement_id
    }),
    removeMinimalIncome: (statement_id, min_income) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "remove_minimal_income",
        statement_id: statement_id,
        min_income: min_income
    }),

    splitMatchUnmatchInfo: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "split_match_unmatch_info",
        statement_id: statement_id
    }),

    splitMatchUnmatch: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "split_match_unmatch",
        statement_id: statement_id
    }),

    //manual match modal

    openStatementLine: (statement_line_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "open_statement_line",
        statement_line_id: statement_line_id
    }),

    searchProductTrack: (statement_id, import_channel = "null", search_str, ignore_channel = false) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "search_product_track",
        statement_id: statement_id,
        import_channel: import_channel,
        search_str: search_str,
        ignore_channel: ignore_channel
    }),
    searchTrack: (search_str) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "search_track",
        search_str: search_str
    }),
    searchMatchProduct: (search_str, channel) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "match_products",
        search: search_str,
        channel: channel,
        import_channel: null
    }),
    searchReleases: (search_str) => MHTTPCL.post(LABEL_URL, {
        section: 'releases',
        action: "filter_releases",
        str: search_str,

    }),
    setRelation: ({ external_id, external_table, external_table2, external_id2, text02, channel }) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "set_relation",
        external_id: external_id,
        external_table: external_table,
        external_table2: external_table2,
        external_id2: external_id2,
        channel: channel,
        text02: text02

    }),

    updateStatementLines: ({ external_id, external_table, channel, statement_id, identifier, match_type, account_id, digital_physical }) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "update_statement_lines",
        external_id: external_id,
        external_table: external_table,
        channel: channel,
        statement_id: statement_id,
        identifier: identifier,
        match_type: match_type,
        account_id: account_id,
        digital_physical: digital_physical

    }),



    uploadStatement: (formData) => {
        return MHTTPCL.postFormData(DISTRIBUTION_URL, formData);
    },
    waitingProcess: () => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "waiting_process",
    }),

    //     importStatement:(
    //         {
    //             statement_id,
    //             fix_country='',
    //             fix_shop='',
    //             return_handling_fee='',
    //             column_names=[],
    //             uploaded_time,
    //             returns_have_leading_minus='0',
    //             fix_digital_type='',
    //             return_identifier='',
    //             distribution_fee_returns='',
    //             distribution_fee_sales=''
    //         }
    //     )=>HttpLib.post("https://batch.berlin3.com/"+MHTTPCL.clientName+DISTRIBUTION_URL,querystring.stringify({
    //         section	:SECSTATEMENT,
    //         action	:"import_statement",
    //         file_type:	"xlsx",
    //         column_names:JSON.stringify(column_names),
    //         uploaded_time:uploaded_time,


    //         fix_shop:fix_shop,
    //         fix_country:fix_country,
    //         fix_digital_type:fix_digital_type,
    //         return_identifier:return_identifier,
    //         distribution_fee_returns:distribution_fee_returns,
    //         distribution_fee_sales:distribution_fee_sales,
    //         return_handling_fee:return_handling_fee,
    //         returns_have_leading_minus:returns_have_leading_minus,
    //         statement_id:statement_id


    //     }, 
    //   { arrayFormat: 'brackets' }),
    //   {
    //     withCredentials: true,

    //   }),
    importStatement: (payload, domain_tld) => HttpLib.post(`https://batch.${domain_tld}/${MHTTPCL.clientName}${DISTRIBUTION_URL}`, querystring.stringify({
        section: SECSTATEMENT,
        ...payload

    },
        { arrayFormat: 'brackets' }),
        { withCredentials: true }
    ),

    channelPresetName: (channel, preset_name) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "channel_preset_name",
        channel: channel,
        preset_name: preset_name,
        output: JSON_STRING
    }),

    newPreset: ({ digital_physical, column_headers_json_str, preset_name, notes }) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "new_preset",
        digital_physical: digital_physical,
        column_headers_json_str: JSON.stringify(column_headers_json_str),
        preset_name: preset_name,
        notes: notes
    }),

    updateStmtCostgroups: (statement_id, costgroup_map) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "update_stmt_costgroups",
        statement_id: statement_id,
        costgroup_map: JSON.stringify(costgroup_map),
        output: JSON_STRING
    }),

    processCostsStatement: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: "process_costs_statement",
        statement_id: statement_id,
        output: JSON_STRING
    }),

    physicalPriceExport: (statement_id) => HttpClient.postJSONasFormData(DISTRIBUTION_URL, {
        section: SECSTATEMENT,
        action: 'physical_price_export',
        statement_id: statement_id

    }, createHttpGetOptions({ responseType: 'blob' })),

    //   https://dev.berlin3.com/updatecheck2/distribution.pl?section=accounts&action=display_statement_unmatched_lines_warning&statement_id=707
    display_statement_unmatched_lines_warning: (statement_id) => MHTTPCL.post(DISTRIBUTION_URL, {
        section: 'accounts',
        action: "display_statement_unmatched_lines_warning",
        statement_id: statement_id
    }),









    //physical
    // statement_id	"233"
    // fix_country	""
    // fix_shop	""
    // return_handling_fee	""
    // distribution_fee_sales	"5.00"
    // distribution_fee_returns	"10.00"
    // return_identifier	""
    // fix_digital_type	""
    // returns_have_leading_minus	"0"
    // column_names	"[\"si_label\",\"ps_artist\",\"ps_title\",\"ps_catalog_no\",\"ps_identifier\",\"ps_format\",\"ps_country\",\"ps_sales\",\"ps_ppd\",\"ps_ppd_total\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\"]"
    // section	"statementsin"
    // action	"import_statement"
    // uploaded_time	"1666257685"
    // file_type	"xlsx"


    //digital

    // statement_id	"234"
    // fix_country	""
    // fix_shop	"Believe"
    // return_handling_fee	""
    // distribution_fee_sales	"2.00"
    // distribution_fee_returns	"10.00"
    // return_identifier	""
    // fix_digital_type	"DL"
    // returns_have_leading_minus	"0"
    // column_names	"[\"ds_identifier\",\"ds_artist\",\"ds_title\",\"ds_barcode\",\"ds_isrc\",\"ds_sales\",\"ds_country\",\"ds_usage_type\",\"ds_shop\",\"ds_ppu\",\"ds_ppu_total\",\"\",\"ds_product_identifier\",\"ds_bundle_track\",\"si_currency\",\"si_currency_amount\",\"ds_offer_type\",\"ds_catalog_no\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\"]"



    //perf

    // statement_id	"235"
    // fix_country	""
    // fix_shop	""
    // return_handling_fee	""
    // distribution_fee_sales	"2.00"
    // distribution_fee_returns	"10.00"
    // return_identifier	""
    // fix_digital_type	""
    // returns_have_leading_minus	"0"
    // column_names	"[\"si_label\",\"ds_artist\",\"ds_title\",\"\",\"ds_isrc\",\"\",\"ds_country\",\"ds_usage_type\",\"ds_shop\",\"\",\"\",\"performance_date\",\"ds_product_identifier\",\"\",\"si_currency\",\"si_currency_amount\",\"\",\"ds_catalog_no\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\"]"









    // external_id	"158"
    // external_table	"track"
    // channel	"digital"
    // statement_id	"157"
    // identifier	"DELUC1912347-Lucie-Oceania+(Vinyl+Cut+Version)"
    // match_type	"digital"
    // account_id	"180"
    // digital_physical	"digital"

    // external_id	"158"
    // external_table	"track"
    // external_table2	"accounts"
    // external_id2	"180"
    // text02	"DELUC1912347-Lucie-Oceania+(Vinyl+Cut+Version)"


























}